import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-help-video-dialog',
  templateUrl: './help-video-dialog.component.html',
  styleUrl: './help-video-dialog.component.scss',
  standalone: false,
})
export class HelpVideoDialogComponent {
  private readonly dialogRef = inject<MatDialogRef<HelpVideoDialogComponent>>(MatDialogRef);

  @ViewChild('video', { static: true }) video!: ElementRef<HTMLVideoElement>;
  public started = false;

  play() {
    this.video.nativeElement.play();
  }

  handlePlay() {
    this.started = true;
  }

  handleEnded() {
    this.dialogRef.close();
  }
}
